(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.closest('[data-option-selector]')) return;

    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    const variants = JSON.parse(form.querySelector('[data-variants-json]').textContent);
    const selectedOptions = Array.from(form.querySelectorAll('[data-option-selector]')).map(
      (select) => select.value
    );

    const variant = variants.find((variant) =>
      variant.options.every((value, index) => value === selectedOptions[index])
    );

    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = form.querySelector('[data-price]');
    const compareAtEl = form.querySelector('[data-compare-at-price]');
    const submitButton = form.querySelector('[data-submit]');

    if (!variant) {
      idInput.value = '';
      submitButton.disabled = true;
      submitButton.textContent = submitButton.dataset.unavailableLabel;
      return;
    }

    idInput.value = variant.id;
    priceEl.textContent = variant.price;

    if (variant.compare_at_price) {
      compareAtEl.textContent = variant.compare_at_price;
      compareAtEl.hidden = false;
    } else {
      compareAtEl.hidden = true;
    }

    submitButton.disabled = !variant.available;
    submitButton.textContent = variant.available
      ? submitButton.dataset.addToCartLabel
      : submitButton.dataset.soldOutLabel;
  });

  } catch(e) { console.error(e); }
})();
})();
